import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { miniToolQueries } from "./queries";
import { MiniToolCard } from "./components/mini-tool-card";

export function MiniToolsPage() {
  const { data, isLoading } = useQuery(miniToolQueries.list());

  return (
    <>
      <title>Mini Tools - Researchly</title>
      <div className="flex flex-col gap-6 p-4 sm:p-6">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-2xl font-semibold tracking-tight">Mini Tools</h1>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {isLoading && (
            <Card className="sm:col-span-2 lg:col-span-3">
              <CardHeader>
                <CardTitle className="text-base">Loading tools…</CardTitle>
                <CardDescription>
                  Fetching available mini tools.
                </CardDescription>
              </CardHeader>
            </Card>
          )}

          {!isLoading &&
            (data ?? []).map((item) => (
              <MiniToolCard key={item.id} item={item} />
            ))}

          {!isLoading && (data?.length ?? 0) === 0 && (
            <Card className="sm:col-span-2 lg:col-span-3">
              <CardHeader>
                <CardTitle className="text-base">No tools available</CardTitle>
                <CardDescription>
                  Check back later for new tools and utilities.
                </CardDescription>
              </CardHeader>
            </Card>
          )}
        </div>
      </div>
    </>
  );
}
